import { useEffect, useState } from 'react'
import { loadTokens, onAuthChange } from '../lib/api/client'
import { AuthScreen } from '../features/auth/AuthScreen'
import { ProjectList } from '../features/projects/ProjectList'
import { EditorScreen } from '../features/editor/EditorScreen'

type Route = { name: 'projects' } | { name: 'editor'; projectId: string }

function parseHash(): Route {
  const hash = window.location.hash.replace(/^#/, '')
  const match = /^\/editor\/([\w-]+)/.exec(hash)
  return match ? { name: 'editor', projectId: match[1]! } : { name: 'projects' }
}

export function App() {
  const [authed, setAuthed] = useState(() => Boolean(loadTokens()))
  const [route, setRoute] = useState<Route>(parseHash)

  useEffect(() => onAuthChange((tokens) => setAuthed(Boolean(tokens))), [])

  useEffect(() => {
    const onHashChange = () => setRoute(parseHash())
    window.addEventListener('hashchange', onHashChange)
    return () => window.removeEventListener('hashchange', onHashChange)
  }, [])

  if (!authed) return <AuthScreen />
  if (route.name === 'editor') return <EditorScreen projectId={route.projectId} />
  return <ProjectList />
}

export function navigate(path: string): void {
  window.location.hash = path
}
